module.exports = __webpack_public_path__ + "static/media/pdf.b838ecd0.png";